import Fingerprint2 from 'fingerprintjs2';

export const fingerprint = async () => {
  try {
    const browserProperties = await Fingerprint2.getPromise({});
    const browserValues = browserProperties.map(({ value }) => value);
    return Fingerprint2.x64hash128(browserValues.join(''), 31);
  } catch (error) {
    return (Math.random() * 1000000).toString(16);
  }
};

export const sessionId = () =>
  (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0];
